import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "./useSourceFlowCollection";
import data from "../.sourceflow/type_of_placement.json";

export const useTypeofPlacements = ({ limit = null } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useTypeofPlacements;
